import AvatarImageCircle from '../AvatarImageCircle';

type ServiceProviderAvatarWithNameProps = {
  serviceProviderAvatarImageUrl: string | undefined | null;
  displayName: string | undefined;
  prefix?: React.ReactNode;
  children?: React.ReactNode;
}

const ServiceProviderAvatarWithName: React.FC<ServiceProviderAvatarWithNameProps> = ({
  serviceProviderAvatarImageUrl,
  displayName,
  prefix,
  children,
}) => {
  return (
    <div className="flex gap-2">
      {serviceProviderAvatarImageUrl ? (
        <div>
          <AvatarImageCircle
            src={serviceProviderAvatarImageUrl}
            alt='Service Provider Avatar'
          />
        </div>
      ) : null/** maybe some default image? */}
      <div className="flex flex-col justify-center">
        {prefix}
        <h3
          className={`font-bold text-2xl ${!displayName && 'skeleton-md'}`}
        >
          {displayName}
        </h3>
        {children}
      </div>
    </div>
  );
};

export default ServiceProviderAvatarWithName;

